import styled from 'styled-components';

const StyledSlider = styled.span`
background-color: ${props => (props.disabledColor === '' ? (props.theme && props.theme.borderColor) : props.disabledColor)};
bottom: 0;
cursor: pointer;
left: 0;
position: absolute;
right: 0;
top: 0;
-webkit-transition: 0.4s;
transition: 0.4s;

:before {
  background-color: white;
  bottom: 4px;
  content: '';
  height: 24px;
  left: 4px;
  position: absolute;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  width: 24px;
}
`;

export default StyledSlider;
